import { useEffect, useState } from 'react';

const useLegacySafariWarningModal = () => {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent;

    const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
    const isIOS = /iP(hone|od|ad)/i.test(userAgent);
    const isMac = /Macintosh|Mac OS X/i.test(userAgent);

    const safariMatch = userAgent.match(/Version\/(\d+)\.(\d+)/);
    const safariMajorVersion = safariMatch ? parseInt(safariMatch[1], 10) : null;

    const isOldSafari = isSafari && safariMajorVersion && safariMajorVersion <= 14;

    if ((isIOS || isMac) && isOldSafari) {
      setShowWarning(true);
    }
  }, []);

  return [showWarning, setShowWarning];
};

export default useLegacySafariWarningModal;
